import { useRef, useEffect, useState } from "react";

import RcPagination from "rc-pagination";

//Unform e componentes
import TooltipItem from "./TooltipItem";

//Util
import { ICONES_PAGINACAO } from "@/frontend/utils/icones";

//Páginas
import SemRegistros from "@/frontend/pages/semRegistros.jsx";

function Paginacao({
  result,
  pageNumber,
  setPageNumber,
  setLimit,
  disabled = false,
}) {
  //### USE REF ###
  const paginationRef = useRef(null);

  //### USE STATE ###
  const [opcoes, setOpcoes] = useState([]);

  const [limitPaginacao, setLimitPaginacao] = useState(10);

  useEffect(() => {
    if (result.items.length > 0 && setLimit) {
      const opcoes = ["5", "10", "15", "20", "25", "30"];

      const opFind = opcoes.find((item) => result.limit == item);

      if (!opFind && result.limit > 0) {
        opcoes.push(result.limit);
        opcoes.sort((a, b) => a - b);
      }
      setOpcoes(opcoes);
      setLimitPaginacao(result.limit);
    }
  }, [result]);

  //### EVENTO: Setas Esquerda e Direita ###
  useEffect(() => {
    const paginationDiv = paginationRef.current;
    if (!paginationDiv) return;

    const handleArrowNavigation = (e) => {
      if (disabled || result.count === 0) return;

      // Seta Direita → (avança página)
      if (e.key === "ArrowRight") {
        e.preventDefault();
        setPageNumber((prev) => {
          const maxPage = Math.ceil(result.count / result.limit);
          return prev < maxPage ? prev + 1 : prev;
        });
      }

      // Seta Esquerda ← (volta página)
      if (e.key === "ArrowLeft") {
        e.preventDefault();
        setPageNumber((prev) => (prev > 1 ? prev - 1 : prev));
      }
    };

    paginationDiv.addEventListener("keydown", handleArrowNavigation);
    return () =>
      paginationDiv.removeEventListener("keydown", handleArrowNavigation);
  }, [result, disabled, setPageNumber]);

  //OnChange - Registros por página
  function handleChangeRegPorPag(event) {
    setLimitPaginacao(event.target.value);
    setLimit(event.target.value);
    setPageNumber(1);
  }

  return (
    <div>
      {result.items.length === 0 && result.limit > 0 && <SemRegistros />}

      {result.items.length > 0 && (
        <div ref={paginationRef} tabIndex={0} className="paginacao">
          <div className="paginacao-inf">
            {result.offset + 1 + " a " + (result.offset + result.items.length)}
            {" de "}
            {result.count}
            {" registros "}
          </div>

          {setLimit && (
            <div className="d-flex align-items-center px-2">
              <TooltipItem text="registros por página">
                <select
                  name="regPorPag"
                  value={limitPaginacao}
                  onChange={handleChangeRegPorPag}
                  className="regPorPag"
                >
                  {opcoes.map((item) => (
                    <option
                      key={item}
                      value={item}
                      //selected={item == result.limit}
                    >
                      {item}
                    </option>
                  ))}
                </select>
              </TooltipItem>
            </div>
          )}

          <RcPagination
            onChange={(page) => setPageNumber(page)}
            current={pageNumber}
            pageSize={result.limit || 0}
            total={result.count}
            nextIcon={ICONES_PAGINACAO.NEXT}
            prevIcon={ICONES_PAGINACAO.PREV}
            disabled={disabled}
          />
        </div>
      )}
    </div>
  );
}

export default Paginacao;
